import React, { useEffect, useState } from 'react';
import {
  formatTimedRunElapsed,
  timedRunElapsedMs,
  useTimedRunClientState,
} from '../../services/TimedRunClientService';
import { windowBridge } from '../framework/windowBridge';
import { ACCENT, COLORS, FONTS, INK } from '../theme';

export const SpeedrunFinishReceipt: React.FC = () => {
  const state = useTimedRunClientState();
  const run = state.message?.run;
  const [dismissedRunId, setDismissedRunId] = useState<string | null>(null);

  useEffect(() => {
    if (run?.status === 'running') setDismissedRunId(null);
  }, [run?.runId, run?.status]);

  const finished = run?.status === 'finished_ranked' || run?.status === 'finished_practice';
  if (!run || !finished || dismissedRunId === run.runId) return null;

  return (
    <div
      data-testid="speedrun-finish-receipt"
      style={{
        position: 'absolute',
        top: 122,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9100,
        pointerEvents: 'auto',
        width: 310,
        padding: 16,
        borderRadius: 10,
        border: `1px solid ${run.status === 'finished_ranked' ? COLORS.success : ACCENT.brassBright}`,
        background: `linear-gradient(155deg, ${INK.hi}, ${INK.lo})`,
        boxShadow: '0 12px 38px rgba(0, 0, 0, 0.62)',
        color: COLORS.textPrimary,
        fontFamily: FONTS.ui,
        textAlign: 'center',
      }}
    >
      <button
        type="button"
        aria-label="Dismiss run receipt"
        onClick={() => setDismissedRunId(run.runId)}
        style={{ position: 'absolute', right: 8, top: 6, border: 0, background: 'transparent', color: COLORS.textMuted, cursor: 'pointer' }}
      >
        ×
      </button>
      <div style={{ color: ACCENT.brassBright, fontSize: 10, letterSpacing: '0.14em' }}>
        THE COIL IS RELIT
      </div>
      <div style={{ marginTop: 7, fontFamily: FONTS.display, fontSize: 17 }}>
        {run.status === 'finished_ranked' ? 'Official Run Complete' : 'Practice Run Complete'}
      </div>
      <div style={{ marginTop: 7, fontFamily: FONTS.mono, fontSize: 28, fontVariantNumeric: 'tabular-nums' }}>
        {formatTimedRunElapsed(timedRunElapsedMs(state))}
      </div>
      <div style={{ minHeight: 16, marginTop: 4, color: COLORS.textSecondary, fontSize: 11 }}>
        {run.rank != null
          ? `Placement #${run.rank}${run.boardTotal != null ? ` of ${run.boardTotal}` : ''}`
          : 'Placement is being calculated'}
      </div>
      <button
        type="button"
        onClick={() => windowBridge.toggle('speedrunRecords')}
        style={{ marginTop: 11, padding: '6px 13px', borderRadius: 5, border: `1px solid ${ACCENT.brass}`, background: COLORS.surfaceRaised, color: COLORS.textPrimary, cursor: 'pointer' }}
      >
        View Coil Records
      </button>
    </div>
  );
};
